import { NoResults, WhiteInstantSearchBuilder } from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import { Hit, Loading } from '../components/projects/results';
import initProjectsSlider from '../../../components/ProjectsSlider';

const sliders = document.querySelectorAll('.projects-slider');
if (sliders.length > 0) {
  const apiUrl = Craft.getSiteUrl('api/react/projects');
  fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json())
    .then((data) => {
      const {
        translates,
        categories,
      } = data;

      const {
        projects,
      } = translates;

      const hitClasses = 'swiper-slide p-0.5! w-75! md:w-117.5!';
      const hitClassesLoading = `${hitClasses} mr-4 md:mr-7.5 last:mr-0`;

      sliders.forEach((slider) => {
        const settings = (slider as HTMLElement)?.dataset || null;
        const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
        if (settings) {
          const indexName = settings.indexName || '';
              const itemCount = Number.parseInt(settings.count as string, 10);

              whiteInstantSearchCatalog
                .withSearchkit(
                  indexName,
                  settings.publicUrl || '',
                  settings.jwt || '',
                  settings.refreshUrl || '',
                )
                .addAdditionalData({
                  translates,
                  categories,
                  hitClasses,
                  hitClassesLoading,
                  itemCount,
                })
                .addHitComponent(
                  [
                    {
                      settings: {
                        noResults: {
                          translations: {
                            noResults: Craft.t(projects, 'Sorry, we can\'t find any projects!'),
                            refinements: Craft.t(projects, 'Try to choose another category or filter.'),
                            query: Craft.t(projects, 'Please try another query.'),
                          },
                        },
                      },
                      component: Hit as HitComponent,
                      loadingComponent: Loading as LoadingComponent,
                      noResultsComponent: NoResults,
                    },
                  ],
                  `#white-instant-search-hits-${settings.id}`,
                )
                .setHitsPerPage(itemCount)
                .setScrolling({
                  includeAttributes: ['page'],
                });

              if (settings.customRefinement) {
                whiteInstantSearchCatalog.whereQuery(settings.customRefinement);
              }

              whiteInstantSearchCatalog
                .afterFirstRender(() => initProjectsSlider(settings.id))
                .build()
                .show();
        }
      });
    });
}